<div *ngIf="showModal" class="popup-wrapper">
  <div class="popup-header">
    <h2 class="popup-title">Preview</h2>
    <div class="custom-close" (click)="closePopup()">×</div>
  </div>

  <div class="popup-body">
    <!-- Main Details: Name, Email, Order #, Total Amount -->
    <div class="info-grid">
      <div class="info-row" *ngFor="let field of displayFields">
        <div class="label">{{ field.label }}</div>
        <div class="value">{{ field.value || "N/A" }}</div>
      </div>
    </div>

    <!-- Shipping Address Section -->
    <div class="section-title">Shipping Address</div>
    <div class="info-grid">
      <div class="info-row" *ngFor="let field of shippingFields">
        <div class="label">{{ field.label }}</div>
        <div class="value">{{ field.value || "N/A" }}</div>
      </div>
    </div>

    <!-- Billing Address Section -->
    <div class="section-title">Billing Address</div>
    <div class="info-grid">
      <div class="info-row" *ngFor="let field of billingFields">
        <div class="label">{{ field.label }}</div>
        <div class="value">{{ field.value || "N/A" }}</div>
      </div>
    </div>

    <!-- Products Section -->
    <div class="section-title">Products</div>
    <div class="product-card" *ngFor="let product of orderData.Product_details">
      <img
        [src]="
          product.product_image ||
          'https://all-frontend-assets.s3.us-east-1.amazonaws.com/divine-infinity-being/custom_button_icons_image/logo_placeholder.png'
        "
      />
      <div class="product-details">
        <div><strong>Name:</strong> {{ product.product_name || "N/A" }}</div>
        <div><strong>Qty:</strong> {{ product.quantity || "N/A" }}</div>
        <div>
          <strong>Price:</strong>
          {{ product.price ? "$" + product.price : product.preorder_price? "$" + product.preorder_price:  "N/A" }}
        </div>
        <div *ngif="product.selected_size"><strong>Size:</strong> {{ product.selected_size || "N/A" }}</div>
        <div *ngif="product.selected_color"><strong>Color:</strong> {{ product.selected_color || "N/A" }}</div>
      </div>
    </div>
  </div>
</div>
